module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/8b8396de66577b7ed3d2f498187c05de.png";